import { nanoid } from 'nanoid'

export const generateID = () => nanoid(10)